import { RequestServices } from '../../../../@types/requests';
import Loading from '../../../../Components/Loading';
import { cpfMask } from '../../../../utils/cpfFormat';
import dateFormat from '../../../../utils/dateFormat';
import NotFound from '../NotFound';
import { CustomTable } from './style';

interface TableReportsProps {
  results: RequestServices[];
  loading: boolean;
}

const TableReports = ({ results, loading }: TableReportsProps) => {
  return (
    <CustomTable responsive="md">
      <thead className="table-header">
        <tr>
          <th>Status</th>
          <th>Protocolo</th>
          <th>CPF do Solicitante</th>
          <th>Órgão</th>
          <th>Setor</th>
          <th>Atendente</th>
          <th>Data de Solicitação</th>
        </tr>
      </thead>
      <tbody className="table-body">
        {loading ? (
          <tr>
            <td colSpan={7}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '850px' }}>
                <Loading />
              </div>
            </td>
          </tr>
        ) : results && results.length > 0 ? (
          results.map((request, index) => (
            <tr key={request.id}>
              <td>{request.status}</td>
              <td>{request.protocolo}</td>
              <td>{cpfMask(request?.cpf)}</td>
              <td>{request.orgao?.sigla}</td>
              <td>{request.setor.nome ? `${request.setor.nome}` : 'Não Consta'}</td>
              <td>{
                request.historico_flow_resposta?.find(resposta => resposta.status === request.status)?.user?.first_name ?? 'Não Consta'
              }</td>
              <td>{dateFormat(request.created_at, true)}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={7}>
              <NotFound />
            </td>
          </tr>
        )}
      </tbody>
    </CustomTable>
  );
};

export default TableReports;